import React from "react";
import Spinner from "../../../components/presentationals/Spinner";
import {
  Grid,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TablePagination,
  TableRow,
  Typography,
  Paper,
  IconButton,
} from "@material-ui/core";
import ReplyIcon from "@material-ui/icons/Reply";
import CallRounded from "@material-ui/icons/CallRounded";
import CustomizedDialog from "./CustomizedDialog";
import TablePaginationActions from "./TablePagination/index";
import { NO_DATA_AVAILABLE } from "../../../utils/constants/index";

const mnpActivationViews = (props) => {
  const {
    filterValue,
    timestampArr,
    mnpActivationObj,
    retailerData,
    classes,
    showTable,
    page,
    backToTop20,
    section,
    renderTableHeader,
    headerKeys,
    rowsPerPage,
    sortedRetailerData,
    StyledTableCell,
    otherRetailerLink,
    handlePaginationOption,
    columnTotal,
    top20ColumnTotal,
    handleChangePage,
    handleChangeRowsPerPage,
  } = props;

  return (
    <div
      className="whitebox wow fadeInUp"
      data-wow-delay=".6s"
      data-wow-duration="0.7s"
    >
      <div className="subtitlebox">
        <div className="subtitleboxChild">{`${filterValue.selectedPartnerRoleName} Dashboard`}</div>
        <div className="card-timestamp">
          <i className="fa fa-history mr-2"></i>
          {timestampArr &&
            timestampArr[0] &&
            timestampArr[0].tileTimestamp?.split(".")[0]}
        </div>
      </div>
      {mnpActivationObj && mnpActivationObj.loading ? (
        <Spinner />
      ) : (
        <Grid
          container
          alignContent="space-around"
          justify="center"
          data-cy="pagination-table"
        >
          <Grid item sm={12} className="table">
            {retailerData && retailerData.length ? (
              <TableContainer className={classes.container} component={Paper}>
                {showTable && page !== 0 ? (
                  <IconButton aria-label="back" onClick={backToTop20}>
                    <ReplyIcon color="primary" />
                  </IconButton>
                ) : null}
                <Table
                  className={classes.table}
                  stickyHeader
                  aria-label="custom pagination table"
                >
                  <caption className={classes.rows}>
                    <CustomizedDialog section={section} />
                  </caption>
                  {renderTableHeader(headerKeys)}
                  <TableBody>
                    {(rowsPerPage > 0
                      ? sortedRetailerData.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                      : sortedRetailerData
                    ).map((row, index) => (
                      <TableRow key={page * rowsPerPage + index + 1}>
                        <StyledTableCell
                          style={{
                            width: 300,
                            textAlign: "left",
                          }}
                          component="th"
                          scope="row"
                          className={classes.rows}
                        >
                          {page * rowsPerPage + index + 1}.
                          {row.partnerName !== "0" ? row.partnerName : null}
                        </StyledTableCell>
                        <StyledTableCell className={classes.rows}>
                          {+row.primaryNo ? (
                            <Link href={`tel:${row.primaryNo}`}>
                              <CallRounded style={{ color: "blue" }} />
                            </Link>
                          ) : null}
                        </StyledTableCell>
                        <StyledTableCell className={classes.rows}>
                          {row.ftdMnpOrders}
                        </StyledTableCell>
                        <StyledTableCell className={classes.rows}>
                          {row.d1MnpOrders}
                        </StyledTableCell>
                        <StyledTableCell className={classes.rows}>
                          {row.d1MnpActivation}
                        </StyledTableCell>
                        {+row.mtdMnpActivations <
                        0.9 * +row.lmtdMnpActivations ? (
                          <StyledTableCell
                            style={{ color: "#FF0000" }}
                            className={classes.rows}
                          >
                            {row.mtdMnpActivations}
                          </StyledTableCell>
                        ) : +row.mtdMnpActivations >=
                            0.9 * +row.lmtdMnpActivations &&
                          +row.mtdMnpActivations <= +row.lmtdMnpActivations ? (
                          <StyledTableCell
                            style={{ color: "#FFBF00" }}
                            className={classes.rows}
                          >
                            {row.mtdMnpActivations}
                          </StyledTableCell>
                        ) : (
                          <StyledTableCell
                            style={{ color: "#000" }}
                            className={classes.rows}
                          >
                            {row.mtdMnpActivations}
                          </StyledTableCell>
                        )}

                        <StyledTableCell className={classes.rows}>
                          {row.lmtdMnpActivations}
                        </StyledTableCell>
                        <StyledTableCell className={classes.rows}>
                          {row.lfmMnpActivations}
                        </StyledTableCell>
                      </TableRow>
                    ))}

                    {page === 0 ? (
                      <>
                        <TableRow>
                          <TableCell
                            key="OtherRetailers"
                            style={{ width: 160, textAlign: "left" }}
                            className={classes.rows}
                            colSpan={2}
                          >
                            <Typography className={classes.root}>
                              {otherRetailerLink ? (
                                <Link href="#" onClick={handlePaginationOption}>
                                  <strong style={{ color: "blue" }}>
                                    Other Retailers+
                                  </strong>
                                </Link>
                              ) : (
                                "Other Retailers+"
                              )}
                            </Typography>
                          </TableCell>
                          {Object.entries(columnTotal).map((column, index) => (
                            <TableCell
                              style={{ width: 160 }}
                              className={classes.rows}
                              key={index}
                            >
                              <strong>
                                {column[1] - top20ColumnTotal[column[0]]}
                              </strong>
                            </TableCell>
                          ))}
                        </TableRow>
                        <TableRow>
                          <TableCell
                            key="Total"
                            component="th"
                            scope="row"
                            className={classes.rows}
                            style={{ textAlign: "left" }}
                          >
                            <strong>Total</strong>
                          </TableCell>
                          <TableCell
                            style={{ width: 160 }}
                            className={classes.rows}
                          ></TableCell>
                          <TableCell
                            style={{ width: 160 }}
                            className={classes.rows}
                          >
                            <strong>{columnTotal.ftdMnpOrders}</strong>
                          </TableCell>
                          <TableCell
                            style={{ width: 160 }}
                            className={classes.rows}
                          >
                            <strong>{columnTotal.d1MnpOrders}</strong>
                          </TableCell>
                          <TableCell
                            style={{ width: 160 }}
                            className={classes.rows}
                          >
                            <strong>{columnTotal.d1MnpActivation}</strong>
                          </TableCell>
                          <TableCell
                            style={{ width: 160 }}
                            className={classes.rows}
                          >
                            <strong>{columnTotal.mtdMnpActivations}</strong>
                          </TableCell>
                          <TableCell
                            style={{ width: 160 }}
                            className={classes.rows}
                          >
                            <strong>{columnTotal.lmtdMnpActivations}</strong>
                          </TableCell>
                          <TableCell
                            style={{ width: 160 }}
                            className={classes.rows}
                          >
                            <strong>{columnTotal.lfmMnpActivations}</strong>
                          </TableCell>
                        </TableRow>
                      </>
                    ) : null}
                  </TableBody>
                  {page !== 0 ? (
                    <TableFooter>
                      <TableRow>
                        <TablePagination
                          rowsPerPageOptions={[]}
                          colSpan={12}
                          count={sortedRetailerData.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          SelectProps={{
                            inputProps: { "aria-label": "rows per page" },
                            native: true,
                          }}
                          onChangePage={handleChangePage}
                          onChangeRowsPerPage={handleChangeRowsPerPage}
                          ActionsComponent={TablePaginationActions}
                        />
                      </TableRow>
                    </TableFooter>
                  ) : null}
                </Table>
              </TableContainer>
            ) : (
              <div className="text-center">{NO_DATA_AVAILABLE}</div>
            )}
          </Grid>
        </Grid>
      )}
    </div>
  );
};

export default mnpActivationViews;
